var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('path',{class:("stroke-" + _vm.color),attrs:{"d":_vm.Pd,"fill":"none","stroke-width":_vm.strong,"stroke-linecap":"round"}})}
var staticRenderFns = []

export { render, staticRenderFns }